// import TennisGame from "../pages/game_page/games_ui/tennis";
// import RocketGame from "../pages/game_page/games_ui/rocket";
// import BoxingGame from "../pages/game_page/games_ui/boxing";

const url = `${process.env.PUBLIC_URL}/build`;

// const unityContext = (gameName) =>
//   new UnityContext({
//     loaderUrl: `${url}/${gameName}/${gameName}.loader.js`,
//     dataUrl: `${url}/${gameName}/${gameName}.data`,
//     frameworkUrl: `${url}/${gameName}/${gameName}.framework.js`,
//     codeUrl: `${url}/${gameName}/${gameName}.wasm`,
//   });

// export const GAME_TO_FILE_MAP = {
//   "@1": [unityContext("franticninja-webgl"), <FranticNinjaGame />],
//   "@2": [unityContext("football"), <FootBallGame />],
//   "@3": [unityContext("endless_runner"), <EndlessRunnerGame />],
//   "@4": [unityContext("fruit_ninja"), <FruitNinjaGame />],
// };
